import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import blog1 from "../../../src/assets/images/blogs-images/1.png";
import blog2 from "../../../src/assets/images/blogs-images/What-is-blogging.jpg";
import blog3 from "../../../src/assets/images/blogs-images/3.png";
import blog4 from "../../../src/assets/images/blogs-images/4.png";

Blog02.propTypes = {};

function Blog02(props) {
    const { data } = props;
    const { className } = props;
    return (
        <section className={className}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="tf-title style-2 style-4">
                            <div className="group-title text-center">
                                <h1>Latest Blogs</h1>
                                {/* <p style={{ maxWidth: '100%' }} className="text-center">Jobtex’s Blog provides valuable content to the job seeker</p> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 wow fadeInUp fadeInUp-blog">
                        <div className="box-latest">
                            <div className="img-latest">
                                <img src={blog1} alt="User Logo" />
                            </div>
                            <div className="box-content">
                                <div className="heading">
                                    {/* <Link to="/blogs/Recruiters-Say-'No-More-Resu-mehs’-as-Skills-Shine-Over-Spills" className="tag">
                                        Design
                                    </Link> */}
                                    <h3>
                                        <Link to="/blogs/Recruiters-Say-'No-More-Resu-mehs’-as-Skills-Shine-Over-Spills"> Recruiters Say 'No More Resu-mehs’ as Skills Shine Over Spills</Link>
                                    </h3>
                                </div>
                                {/* <ul className="date-post">
                                    <li>by Themeflat</li>
                                    <li>
                                        <span className="icon-calendar"></span>
                                        2 days ago
                                    </li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 wow fadeInUp fadeInUp-blog">
                        <div className="box-latest">
                            <div className="img-latest">
                                <img src={blog3} alt="User Logo" />
                            </div>
                            <div className="box-content">
                                <div className="heading">
                                    {/* <Link to="/blogs/A-Strategic-Approach-to-Closing-Skill-Gaps-in-the-Digital-Age" className="tag">
                                        Design
                                    </Link> */}
                                    <h3>
                                        <Link to="/blogs/A-Strategic-Approach-to-Closing-Skill-Gaps-in-the-Digital-Age">A Strategic Approach to Closing Skill Gaps in the Digital Age</Link>
                                    </h3>
                                </div>
                                {/* <ul className="date-post">
                                    <li>by Themeflat</li>
                                    <li>
                                        <span className="icon-calendar"></span>
                                        2 days ago
                                    </li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 wow fadeInUp fadeInUp-blog">
                        <div className="box-latest">
                            <div className="img-latest" >
                                <img src={blog4} alt="User Logo" />
                            </div>
                            <div className="box-content">
                                <div className="heading">
                                    {/* <Link to="/blogs/How-to-Retain-Your-Top-Performers-by-Building-Inclusive-Workplaces" className="tag">
                                        Design
                                    </Link> */}
                                    <h3>
                                        <Link to="/blogs/How-to-Retain-Your-Top-Performers-by-Building-Inclusive-Workplaces">How to Retain Your Top Performers by Building Inclusive Workplaces</Link>
                                    </h3>
                                </div>
                                {/* <ul className="date-post">
                                    <li>by Themeflat</li>
                                    <li>
                                        <span className="icon-calendar"></span>
                                        2 days ago
                                    </li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Blog02;
